module.exports = __webpack_public_path__ + "ed494c101c8e9c777dd6918148499270.png";